
class ComparisonConstants {
    public static PercentagePivots = {
        bad: 30,
        neutral: 50,
        good: 70,
        amazing: 100
    };

    public static MBTIAnswers = {
        bad: "Yikes...",
        fine: "Fine, I guess",
        good: "Good",
        amazing: "Amazing!"
    };
}

export default ComparisonConstants;